import { readonly, ref } from 'vue'

/**
 * Which organization the console acts in — sent as `X-Org-Id` on every call.
 *
 * mdm-service decides the organization from the token's `organization` claim; the header
 * only chooses between several (or, for a platform admin, names any). Remembered per
 * browser, like the interface language.
 */
const STORAGE_KEY = 'mdm.org'

const selected = ref<string | null>(localStorage.getItem(STORAGE_KEY))

export const selectedOrganization = readonly(selected)

export function selectOrganization(alias: string | null): void {
  selected.value = alias
  if (alias) {
    localStorage.setItem(STORAGE_KEY, alias)
  } else {
    localStorage.removeItem(STORAGE_KEY)
  }
}
